var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-input',{attrs:{"setup":{
    'func': _vm.setPropertyValueTypeHandler,
    'args': {
      'model': _vm.$props,
      'key': 'type',
      'options': _vm.propertyValueTypeOptions,
      'clearable': false,
      'prefix': ((_vm.snakeCase(_vm.ActionTypes.Property)) + "_action_"),
      'disabled': !_vm.currentProperty || !_vm.action,
      'validation': 'required',
    }
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }